<form [attr.disabled]="configurationForm().disabled">
  <glxy-form-field>
    <glxy-label>{{ 'AI_ASSISTANT.SETTINGS.SALES_COACH.DISPLAY_NAME_LABEL' | translate }}</glxy-label>
    <input type="text" matInput value="Notetaker" [disabled]="true" />
    <glxy-hint>{{ 'AI_ASSISTANT.SETTINGS.SALES_COACH.DISPLAY_NAME_DESCRIPTION' | translate }}</glxy-hint>
  </glxy-form-field>
</form>
